export const ApiUrl = 'https://development.pakodemy.com/api/';
export const ApiUrlAdmin = 'https://api.pakodemy.com/api/';
export const ApiUrlDevelop = 'https://development.pakodemy.com/api/';
// export const ApiUrl = 'http://localhost:5001/';
